import { Instagram, TikTok, Twitter, Youtube, defaultUser } from '@hub/shared'
import './profile-image.component.scoped.scss'

interface Props {
  socialNetworkObject: Instagram | Youtube | Twitter | TikTok
}

export default ({ socialNetworkObject }: Props) => {
  return (
    <figure>
      <img
        onError={({ currentTarget }) => {
          currentTarget.src = defaultUser
        }}
        src={socialNetworkObject?.picture}
        alt={socialNetworkObject?.username}
        title={socialNetworkObject?.username}
        className="img-fluid"
      />
    </figure>
  )
}
